import { render } from "./AppGrafica.vue?vue&type=template&id=81b047c0&scoped=true"
import script from "./AppGrafica.vue?vue&type=script&lang=js"
export * from "./AppGrafica.vue?vue&type=script&lang=js"

import "./AppGrafica.vue?vue&type=style&index=0&id=81b047c0&scoped=true&lang=css"

import exportComponent from "/home/appalala/repositorios/alala/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81b047c0"]])

export default __exports__